module.exports = __webpack_public_path__ + "img/value1.7b5be5ee.png";